import { z } from 'zod';

export const stringMessageSchema = z.string();
